import styled from "styled-components";
import { media } from "../../theme/theme";

export const AddContentUploadWrapper = styled.div`
    border: 1px dashed ${({ theme }) => theme.v3.colors.grey48};
    padding: 12px 6px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
        border: 1px dashed ${({ theme }) => theme.v3.colors.grey35};
    }

    > div {
        &:first-child {
            margin-right: 12px;
        }
    }
`;

export const OptionsWrapper = styled.div<{ $useCol?: boolean }>`
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    > a {
        display: block;
        width: 100%;

        ${media.custom(550)} {
            max-width: ${({ $useCol }) => $useCol ? "calc(50% - 5px)" : undefined};
        }  
    }
`;